import axios from "axios";

import { baseURL, LMS_BASE_URL } from "../../../../utils/http/http-common";

import { LMS_TOKEN } from "../../../../utils/cookiesmanager";

import { getLMSData } from "../../../../utils/getLMSData";

export const getFinalAssessmentQuestionApiCall = async (args) => {
    const { languageid = 1 , userTypeId} = args;

    const userId = localStorage.getItem("id")

    const authToken = localStorage.getItem(LMS_TOKEN);

    try {
    const response = await axios.get(
      `${baseURL}/FinalAssessment/Questions/${userTypeId}/${languageid}`,{
        headers:{
            Authorization:`Bearer ${authToken}`
        }
      }
    );
    return response.data;
  } catch (error) {
    return error.config.data;
  }
};

export const savePostChapterAssessment = async (payload) => {
  const {questionArray} = payload;
 
    const userId = localStorage.getItem("id");
    const userTypeId = localStorage.getItem("userTypeId");

    const authToken = localStorage.getItem(LMS_TOKEN);

    try {
    const response = await axios.post(
      `${baseURL}/FinalAssessment/SaveUserInput/${userId}/${userTypeId}`, questionArray ,{
        headers:{
            Authorization:`Bearer ${authToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return error.config.data;
  }
};